import type { SVGProps } from 'react';

import { unitMapping, type Unit } from '#src/lib/style.ts';

export const ArenaIcon = (props: SVGProps<SVGSVGElement> & { size?: Unit }) => {
  const { size = 3 } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      style={{ height: unitMapping[size], width: 'auto' }}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.0236 6.69336C7.27015 6.61087 10.1564 6.70508 10.1564 6.70508L11.9523 9.9248L13.842 6.70312L17.1652 6.67676C17.1863 6.99957 17.0525 7.39521 17.341 7.61914L17.339 7.61719H20.3322C20.3698 9.97879 19.3672 12.1354 17.4347 13.4883C16.8183 13.9225 15.2554 14.6733 15.2258 14.6875L12.9621 17.4834L12.9924 19.5264L14.1105 22.2324H16.2824L16.5754 24H7.41814L7.65251 22.2324H9.88396L10.8888 19.5264L11.0392 17.3604C11.0392 17.3604 8.94023 14.7354 8.79899 14.6006C8.65346 14.4616 7.29216 13.9647 6.9113 13.7266C5.56132 12.8782 4.34515 11.3084 3.95524 9.74121C3.85897 9.35468 3.647 8.23938 3.66814 7.90234C3.67521 7.79392 3.76958 7.61914 3.84001 7.61914H6.65544L7.0236 6.69336ZM5.01384 8.68262C4.77434 8.8476 5.01406 9.5032 5.10564 9.76953H5.10271C5.56297 11.1152 6.56153 12.2225 7.77067 12.9248C7.44899 11.5861 6.94589 10.2826 6.93181 8.87793L6.77458 8.68262H5.01384ZM17.2238 8.68066L17.0666 8.87598C17.0971 10.2948 16.5658 11.5842 16.2277 12.9229C17.7984 12.0556 18.9582 10.507 19.1603 8.68066H17.2238Z"
        fill="currentColor"
      />
      <path
        d="M13.216 2.48633L15.757 3.94727L13.0168 5.31445L12.0002 7.61035L10.9455 5.31445L8.24333 3.94727L10.7463 2.48633L12.0002 0L13.216 2.48633Z"
        fill="currentColor"
      />
    </svg>
  );
};
